export default {
    NAME: 'Kaetram',
    DESCRIPTION:
        'Kaetram ist eine Open-Source Spiele-Engine, die entwickelt wurde, um Interessierten den Einstieg in die Spieleentwicklung zu erleichtern. Die ursprüngliche Idee basiert auf dem Demospiel von Little Workshop - BrowserQuest. Die Assets sind die gleichen geblieben, aber der Code selbst wurde komplett gelöscht und von Grund auf neu entwickelt.'
} as const;
